import React from "react";

const CustomButton = ({
  label,
  onClick = "",
  disabled,
  type = "button",
  icon,
  buttonClass,
  labelClass,
  iconClass,
  link,
  contentLength1 = null,
  contentType1 = null,
  contentLength2 = null,
  contentType2 = null,
  contentLengthClass = null,
}) => {
  const buttonContent = (
    <>
      <div className="d-flex gap10 t03 align-items-center">
        {icon && <span className={`${iconClass}`}>{icon}</span>}
        <span className={labelClass}>
          {label}
          <p className={contentLengthClass}>
            {contentLength1} {contentType1} {contentLength2 && "|"}
            {contentLength2} {contentType2}
          </p>
        </span>
      </div>
    </>
  );

  if (link) {
    return (
      <a
        href={link}
        className={`custom-button t03 ${buttonClass}`}
        onClick={onClick && onClick}
        aria-disabled={disabled}
      >
        {buttonContent}
      </a>
    );
  }

  return (
    <button
      style={{ zIndex: "1" }}
      type={type}
      onClick={onClick}
      className={`custom-button t03 border-0 ${buttonClass} ${
        disabled ? "btn-disabled" : ""
      }`}
      disabled={disabled}
    >
      {buttonContent}
    </button>
  );
};

export default CustomButton;
